import React, { createContext, useContext, useState, ReactNode } from 'react';
import PremiumFeatureModal from '../components/PremiumFeatureModal';

interface PremiumModalContextType {
  showPremiumModal: (featureName?: string) => void;
}

const PremiumModalContext = createContext<PremiumModalContextType | undefined>(undefined);

export const usePremiumModal = () => {
  const context = useContext(PremiumModalContext);
  if (!context) {
    throw new Error('usePremiumModal must be used within a PremiumModalProvider');
  }
  return context;
};

interface PremiumModalProviderProps {
  children: ReactNode;
}

export const PremiumModalProvider: React.FC<PremiumModalProviderProps> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [featureName, setFeatureName] = useState<string>('AI generation');

  const showPremiumModal = (feature?: string) => {
    setFeatureName(feature || 'AI generation');
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <PremiumModalContext.Provider value={{ showPremiumModal }}>
      {children}
      <PremiumFeatureModal 
        isOpen={isOpen} 
        onClose={handleClose}
        featureName={featureName}
      />
    </PremiumModalContext.Provider>
  );
};